import roundDecimals from './roundDecimals'
import convertUnit from './convertUnit'

export default (value, decimals = 1) => {
  const distance = convertUnit(value)
  const roundedDistance = roundDecimals(distance.val, decimals)
  return roundedDistance >= 0 && `${roundedDistance} ${distance.unit}`
}
